// ===== Enums =====

export enum CustomFieldDataType {
  String = 'String',
  Integer = 'Integer',
  Number = 'Number',
  Date = 'Date',
  DateTime = 'DateTime',
  Boolean = 'Boolean',
}

export enum CustomFieldType {
  None = 'None',
  SelectOne = 'SelectOne',
  SelectMany = 'SelectMany',
}

// ===== Supporting Models =====

export interface CustomFieldOption {
  name: string | null;
  value: string | null;
}

// ===== View Models =====

export interface CustomFieldViewModel {
  tenantId: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string | null;
  updatedBy: string | null;
  customFieldId: number;
  name: string | null;
  dataType: CustomFieldDataType;
  inactive: boolean;
  fieldType: CustomFieldType;
  options: CustomFieldOption[] | null;
}

// ===== Request Models =====

export interface CreateOrUpdateCustomFieldViewModel {
  customFieldId?: number | null;
  name: string | null;
  dataType: CustomFieldDataType;
  fieldType: CustomFieldType;
  inactive: boolean;
  options: CustomFieldOption[] | null;
}

